@if (hasTitle === true) {
  <div class="list-placeholder-title"></div>
}
@for (item of loadingSkeletonSize; track $index) {
  <div class="list-item-placeholder">
    @if (hasImageColumn === true) {
      <div class="__image-col">
        <div class="__image"></div>
      </div>
    }
    @for (col of columns; track $index) {
      <div class="__col">
        @for (line of lines; track $index) {
          <div class="__line">&nbsp;</div>
        }
      </div>
    }
  </div>
}
